import { ThunkHelper } from 'invision-core';
export var GET_WORKFLOW_ACTIVITY_INSTANCE_STATUS = {
  BEGIN: 'GET_WORKFLOW_ACTIVITY_INSTANCE_BEGIN',
  SUCCESS: 'GET_WORKFLOW_ACTIVITY_INSTANCE_SUCCESS',
  FAILURE: 'GET_WORKFLOW_ACTIVITY_INSTANCE_FAILURE'
};
var GET_WORKFLOW_ACTIVITY_INSTANCE_EVENTS = [GET_WORKFLOW_ACTIVITY_INSTANCE_STATUS.BEGIN, GET_WORKFLOW_ACTIVITY_INSTANCE_STATUS.SUCCESS, GET_WORKFLOW_ACTIVITY_INSTANCE_STATUS.FAILURE];
export var createWorkflowActivityInstancePromise = function createWorkflowActivityInstancePromise(dispatch) {
  var workflowInstanceIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return ThunkHelper(dispatch, GET_WORKFLOW_ACTIVITY_INSTANCE_EVENTS, {
    method: 'post',
    url: 'Workflow/RetrieveWorkflowInstances',
    data: {
      WorkflowInstanceIds: workflowInstanceIds
    }
  }, {
    workflowInstanceIds: workflowInstanceIds
  });
};
export var getWorkflowActivityInstance = function getWorkflowActivityInstance(workflowInstanceIds) {
  return function (dispatch) {
    return createWorkflowActivityInstancePromise(dispatch, workflowInstanceIds);
  };
};